import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { wheels } from '../../../../reducers/wheels/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  wheels,
});

const options = ({ wheels, availableOptions }) =>
  getDropdownOptions(wheels, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['wheelFormPlaceHolder'] }),
  connect(mapStateToProps),
  addProps({ options }),
);
